import { ChangeEvent, KeyboardEvent, useEffect, useRef, useState } from 'react';
import { InputBase } from '@material-ui/core';
import { IconSearch } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import styles from './searchDialog.module.scss';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  // Texto tras "Puedes buscar por:" (por defecto, "palabras")
  searchBy?: string;
  setSearch?: (value: string) => void;
  setOffset?: (value: number) => void;
  onSearch?: (value: string) => void;
  // Limpia la búsqueda aplicada al abrir el cuadro (Pedidos)
  clearSearchOnOpen?: boolean;
}

/**
 * Cuadro de búsqueda de los listados del viajero (Ofertas, Acuerdos y Pedidos).
 * Enter o "Buscar" aplican la búsqueda y cierran; con el campo vacío no hacen nada.
 */
const SearchDialog = (props: SearchDialogProps) => {
  const {
    open = false,
    onClose,
    searchBy = '',
    setSearch,
    setOffset,
    onSearch,
    clearSearchOnOpen = false,
  } = props;
  const [searchx, setSearchx] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const searchByText = searchBy === '' ? 'palabras' : searchBy;

  const handleChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchx(event.target.value);
  };

  const handleSend = () => {
    if (!searchx) {
      return;
    }
    if (setSearch) setSearch(searchx);
    if (onSearch) onSearch(searchx);
    if (setOffset) setOffset(0);
    onClose();
  };

  const handleKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };

  useEffect(() => {
    if (!open) return undefined;
    setSearchx('');
    if (clearSearchOnOpen && setSearch) setSearch('');
    // No sirve autoFocus: el foco se asienta después de montar el contenido del Modal
    const timer = window.setTimeout(() => inputRef.current?.focus(), 0);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <ModalHeader icon={<IconSearch />} tone="info">
        <ModalTitle>Buscar</ModalTitle>
        <ModalDescription>
          <strong>Puedes buscar por:</strong> {searchByText}
        </ModalDescription>
      </ModalHeader>
      <ModalBody>
        <div className={styles.field}>
          <IconSearch size={20} className={styles.icon} aria-hidden="true" />
          <InputBase
            fullWidth
            className={styles.input}
            placeholder="ej. ebay"
            inputRef={inputRef}
            inputProps={{ 'aria-label': 'Buscar' }}
            onKeyUp={handleKeyUp}
            value={searchx}
            onChange={handleChangeSearch}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose}>
          Cancelar
        </Button>
        <Button onClick={handleSend}>Buscar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default SearchDialog;
